<template>
  <div>
   <!-- Navbar-->
    <!-- Remove "navbar-sticky" class to make navigation bar scrollable with the page.-->
    <header class="navbar navbar-sticky">
      <!-- Site Branding-->
      <div class="site-branding"><a class="site-logo hidden-xs-down" href="https://luxuryshopdz.com/#/all">
        <img src="static/img/logo/logo.png" alt="luxuryShop dz"></a><a class="site-logo logo-sm hidden-sm-up" to='/'><img src="static/img/logo/logo-sm.png" alt="luxuryshopdz"></a>
        <!--<div class="lang-currency-switcher">
          <div class="lang-currency-toggle"><img src="static/img/flags/GB.png" alt="English"><span>USD</span><i class="material-icons arrow_drop_down"></i>
            <ul class="lang-currency-dropdown">
              <li>
                <select class="form-control form-control-sm">
                  <option value="usd">$ USD</option>
                  <option value="usd">€ EUR</option>
                  <option value="usd">£ UKP</option>
                  <option value="usd">¥ JPY</option>
                </select>
              </li>
              <li><a href="#"><img src="static/img/flags/FR.png" alt="Français">Français</a></li>
              <li><a href="#"><img src="static/img/flags/DE.png" alt="Deutsch">Deutsch</a></li>
              <li><a href="#"><img src="static/img/flags/IT.png" alt="Italiano">Italiano</a></li>
            </ul>
          </div>
        </div>
        -->
      </div>
      <!-- Main Navigation-->
      <nav class="site-menu">
        <ul>
          <router-link tag="li" to='/'><a><span><strong>Accueil</strong></span></a></router-link>
          <router-link tag="li" to='/all'><a><span><strong>Tous</strong></span></a></router-link>
          <router-link tag="li" to='/men'><a><span><strong>Homme</strong></span></a></router-link>
          <router-link tag="li" to='/women'><a><span><strong>Femme</strong></span></a></router-link>
           <router-link tag="li" to='/nautica'><a><span><strong> <font color="red">Promotion</font></strong></span></a></router-link>
          
         <!--<router-link tag="li" to='/top'><a><span><strong> <font color="red">Top modéles</font></strong></span></a></router-link-->

          <li><a href="#"><span><strong>Marque</strong></span></a>
            <ul class="sub-menu">
                <router-link tag="li" to="/festina"><a><span><strong>FESTINA</strong></span></a></router-link>
                  <router-link tag="li" to="/maserati"><a><span><strong>MASERATI</strong></span></a></router-link>
                 <router-link tag="li" to="/versus"><a><span><strong>VERSUS</strong></span></a></router-link>
                   <router-link tag="li" to="/trussardi"><a><span><strong>TRUSSARDI</strong></span></a></router-link>
                     
                <router-link tag="li" to="/morellato"><a><span><strong>MORELLATO</strong></span></a></router-link>
               
                <router-link tag="li" to="/nautica"><a><span><strong>Promotion</strong></span></a></router-link>
                <router-link tag="li" to="/timberland"><a><span><strong>TIMBERLAND</strong></span></a></router-link>
                <router-link tag="li" to="/Michaelkors"><a><span><strong>MICHAEL KORS</strong></span></a></router-link>
                
                <router-link tag="li" to="/armani"><a><span><strong>ARAMANI EXCHANGE </strong></span></a></router-link>
              
                  <router-link tag="li" to="/fossil"><a><span><strong>FOSSIL</strong></span></a></router-link>
                 
                   <router-link tag="li" to="/connectee"><a><span><strong>CONNECTEE</strong></span></a></router-link>

            </ul>
          </li>
          <router-link tag="li" to="/achat"><a><span><strong>COMMENT ACHETER </strong></span></a></router-link>
          <router-link tag="li" to='/contact'><a><span><strong>CONTACT</strong></span></a></router-link>

        </ul>
      </nav>
      <!-- Toolbar-->
      <div class="toolbar">
        <div class="inner">
          <a @click="isActive=!isActive" class="toolbar-toggle mobile-menu-toggle" :class="{active:isActive}" href="#mobileMenu">
             <i class="material-icons menu"></i>
          </a>

          <a @click="isCart=!isCart" class="toolbar-toggle" :class="{active:isCart}" href="#cart">
             <i><span class="material-icons shopping_basket">
          </span><span class="count">{{itemsInCart}}</span></i>
          </a>
      </div>
        <!-- Toolbar Dropdown-->
        <div class="toolbar-dropdown" :class="{open:isActive}">
          <!-- Mobile Menu Section-->
          <div class="toolbar-section" id="mobileMenu">
            <!-- Slideable (Mobile) Menu-->
            <nav class="slideable-menu mt-4">
              <ul class="menu">
               <router-link @click.native="isActive=false" tag="li" to="/"><a><span><strong>Accueil</strong></span></a></router-link>
               <router-link @click.native="isActive=false" tag="li" to="/all"><a><span><strong>Tous</strong></span></a></router-link>
               <router-link @click.native="isActive=false" tag="li" to="/men"><a><span><strong>Homme</strong></span></a></router-link>
               <router-link @click.native="isActive=false" tag="li" to="/women"><a><span><strong>Femme</strong></span></a></router-link>
                      <router-link @click.native="isActive=false" tag="li" to="/nautica"><a><span><strong><font color="red">PROMOTION</font></strong></span></a></router-link>
              <!-- <router-link @click.native="isActive=false" tag="li" to="/top"><a><span><strong><font color="red">Top modéles</font></strong></span></a></router-link>-->
              <li class="has-children"><span><a href="#"><span><strong>Marque</strong></span></a><span class="sub-menu-toggle"></span></span>
                  <ul class="slideable-submenu">
                     <router-link @click.native="isActive=false" tag="li" to="/festina"><a><span><strong>Festina</strong></span></a></router-link>
                      <router-link @click.native="isActive=false" tag="li" to="/maserati"><a><span><strong>Maserati</strong></span></a></router-link>
                     <router-link @click.native="isActive=false" tag="li" to="/versus"><a><span><strong>Versus</strong></span></a></router-link>
                      <router-link @click.native="isActive=false" tag="li" to="/trussardi"><a><span><strong>TRUSSARDI</strong></span></a></router-link>
                       
                     <router-link @click.native="isActive=false" tag="li" to="/morellato"><a><span><strong>Morellato</strong></span></a></router-link>
                         <router-link @click.native="isActive=false" tag="li" to="/fossil"><a><span><strong>Fossil</strong></span></a></router-link>
                     
                   
                        <router-link @click.native="isActive=false" tag="li" to="/timberland"><a><span><strong>Timberland</strong></span></a></router-link>
                     <router-link @click.native="isActive=false" tag="li" to="/Michaelkors"><a><span><strong>Michael kors</strong></span></a></router-link>
                     <router-link @click.native="isActive=false" tag="li" to="/armani"><a><span><strong>Armani exchange</strong></span></a></router-link>
                       <router-link @click.native="isActive=false" tag="li" to="/diesel"><a><span><strong>Diesel</strong></span></a></router-link>
                          <router-link @click.native="isActive=false" tag="li" to="/nautica"><a><span><strong>Nautica</strong></span></a></router-link>
                 
                     <router-link @click.native="isActive=false" tag="li" to="/lotus"><a><span><strong>Lotus</strong></span></a></router-link>
                     <router-link @click.native="isActive=false" tag="li" to="/connectee"><a><span><strong>Connectee</strong></span></a></router-link>
                   </ul>
              </li>
              <router-link @click.native="isActive=false" tag="li" to="/achatmobile"><a><span><strong>Comment acheter</strong></span></a></router-link>
              <router-link @click.native="isActive=false" tag="li" to="/contact"><a><span><strong>Contact</strong></span></a></router-link>

              </ul>
            </nav>
          </div>
          <!-- Search Section-->
          <div class="toolbar-section" id="search">
            <!-- Products-->
            <div class="widget widget-featured-products">
              <h3 class="widget-title">Found in Products</h3>

            </div>
            <!-- Blog-->
            <div class="widget widget-featured-products">
              <h3 class="widget-title">Found in Blog</h3>
            </div>
          </div>
          <!-- Account Section-->
          <div class="toolbar-section" id="account">
            <ul class="nav nav-tabs nav-justified" role="tablist">
              <li class="nav-item"><a class="nav-link active" href="#login" data-toggle="tab" role="tab">Connecter</a></li>
              <li class="nav-item"><a class="nav-link" href="#register" data-toggle="tab" role="tab">Créer votre compte</a></li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane fade show active" id="login" role="tabpanel">
                <form v-if="!isAuthenticated" @submit.prevent="login" autocomplete="off" id="login-form">
                  <div class="form-group input-group">
                    <input class="form-control" type="text" placeholder="E-mail" required v-model="email">
                    <span class="input-group-addon"><i class="material-icons mail"></i></span>
                  </div>
                   <div class="form-group input-group">
                    <input class="form-control" type="text" placeholder="phone" required v-model="phonenumber">
                    <span class="input-group-addon"><i class="material-icons mail"></i></span>
                  </div>
                  <div class="form-group input-group">
                    <input class="form-control" type="password" placeholder="Mot de passe" required v-model="password">
                    <span class="input-group-addon"><i class="material-icons lock"></i></span>
                  </div>
                  <div class="custom-control custom-checkbox form-group">
                    <input class="custom-control-input" type="checkbox" id="logged" checked>
                    <label class="custom-control-label" for="logged">Rester connecté</label>
                  </div>
                  <button class="btn btn-primary btn-block" type="submit">S'identifier</button>
                </form>
                <form v-else @submit.prevent="logout">
                   <p>Vous étes connecté !!!!</p>
                   <button class="btn btn-primary btn-block" type="submit">Se déconnecter</button>
                </form>
              </div>
              <div class="tab-pane fade" id="register" role="tabpanel">
                <form v-if="!isAuthenticated" autocomplete="off" @submit.prevent="register" id="register-form">
                  <div class="form-group">
                    <input class="form-control" type="text" placeholder="Email" required v-model="emailregister">
                  </div>

                  <div class="form-group">
                    <input class="form-control" type="password" placeholder="Mot de passe" required v-model="passwordregister">
                  </div>
                  <button class="btn btn-primary btn-block" type="submit">Inscrire</button>
                  <p class="text-muted text-sm mt-4">OU inscrivez-vous avec votre compte social</p>
                  <a class="media-btn media-facebook" href="#" @click="openFbLoginDialog">
                    <i class="socicon-facebook"></i>
                    <span>Inscrivez-vous avec Facebook</span>
                  </a>
                  <!--<a class="media-btn media-google" href="#">
                    <i class="socicon-googleplus"></i>
                    <span>Signup with Google+</span>
                  </a>
                  <a class="media-btn media-twitter" href="#">
                    <i class="socicon-twitter"></i>
                    <span>Signup with Twitter</span>
                  </a>
                  -->
                </form>
                <form v-else @submit.prevent="logout">
                   <p>vous êtes authentifié!!!!</p>
                   <button class="btn btn-primary btn-block" type="submit">Log Off</button>
                </form>
              </div>
            </div>
          </div>
          <!-- Shopping Cart Section-->
          <div  class="toolbar-section" id="cart">
            <div class="table-responsive shopping-cart mb-0">
              <table class="table">
                <thead>
                  <tr>
                    <th colspan="2">
                      <div class="d-flex justify-content-between align-items-center">Produits
                        <router-link @click.native="cancelCart" class="navi-link text-uppercase" to="/cart">
                          <span class="text-xxs">Votre Panier</span>
                          <i class="material-icons keyboard_arrow_right"></i>
                        </router-link>
                     </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="product in products" v-bind:key="product.id">
                    <td>
                      <div class="product-item"><a class="product-thumb" href="shop-single.html">
                        <img :src="product.img" alt="Product"></a>
                        <div class="product-info">
                          <h4 class="product-title"><a href="shop-single.html">{{product.name}}</a>
                          </h4><span><em>Prix:</em> {{product.price}}</span><span><em>Quantité:</em> {{product.quantity}}</span>
                        </div>
                      </div>
                    </td>
                    <td class="text-center"><a class="remove-from-cart" href="#" @click="removeItem(product)"><i class="material-icons icon_close"></i></a></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <hr class="mb-3">
            <div class="d-flex flex-wrap justify-content-between align-items-center">
              <div class="pr-2 py-1 text-sm">TOTAL: <span class='text-dark text-medium'>{{total}}</span></div>
              <router-link @click.native="cancelCart" class="btn btn-sm btn-success mb-0 mr-0" to="/checkout">Commander</router-link>
            </div>
          </div>
        </div>
      </div>

    </header>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import axios from 'axios';

export default {
  data() {
    return {
      isActive: false,
      isAccount: false,
      isCart: false
    };
  },
  computed: {
    products() {
      return this.$store.getters.cartProducts;
    },

    itemsInCart() {
      let cart = this.$store.getters.cartProducts;
      return cart.reduce((accum, item) => accum + item.quantity, 0);
    },
    total() {
      return this.products.reduce((total, p) => {
        return total + p.price * p.quantity;
      }, 0);
    },
    ...mapGetters({ isAuthenticated: 'isAuthenticated' }),
    ...mapFields(['loginInfo.email', 'loginInfo.password', 'loginInfo.phonenumber' ,'registreInfo.emailregister','registreInfo.prenomregister','registreInfo.nomregister','registreInfo.phonenumberregister','registreInfo.passwordregister'])
  },
  methods: {
    cancelCart() {
      this.isActive = true;
      this.$nextTick(() => (this.isActive = false));
      this.isCart = false;
    },
    cancelAccount() {
      this.isActive = true;
      this.$nextTick(() => (this.isActive = false));
      this.isAccount = false;
    },
    openFbLoginDialog() {
      FB.login(this.checkLoginState, { scope: 'email' });
    },
    checkLoginState: function(response) {
      if (response.status === 'connected') {
        console.log(response.authResponse.accessToken);
        this.$store.dispatch('fblogin', response.authResponse.accessToken);
        this.cancelAccount();
        /*FB.api('/me', { fields: 'name,email' }, function(profile) {
          console.log('Good to see you, ' + profile.name + '.');
        });

      } else if (response.status === 'not_authorized') {
        // the user is logged in to Facebook,
        // but has not authenticated your app
      } else {
        // the user isn't logged in to Facebook.
      }*/
      }
    },
    login() {
      this.$store.dispatch('login');
      this.cancelAccount();
    },
    register() {
      this.$store.dispatch('register');
      this.cancelAccount();
    },
    logout() {
      this.$store.dispatch('logout');
      this.cancelAccount();
    },
    ...mapActions(['removeItem'])
  }
};
</script>

<style scoped>
/*.site-menu li a {
  text-transform: none;
}*/
</style>




// WEBPACK FOOTER //
// src/components/navigation.vue